import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

export const VideosStyled = styled.div`
  padding: 5rem 0;

  @media (max-width: ${breakpoints.screenSM}) {
    padding: 3rem 0;
  }

  .title {
    max-width: 910px;
    padding: 0 1rem;
    margin-bottom: 5rem;
    text-align: center;

    @media (max-width: ${breakpoints.screenMD}) {
      margin-bottom: 3rem;
    }

    @media (max-width: ${breakpoints.screenSM}) {
      br {
        display: none;
      }
    }
  }

  .videos-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    width: 100%;

    @media (max-width: ${breakpoints.screenSM}) {
      gap: 0.3rem;
    }
  }

  .videos-row {
    display: flex;
    gap: 0.4rem;
    width: 100%;

    @media (max-width: ${breakpoints.screenSM}) {
      gap: 0.3rem;
    }

    &.upper {
      height: 50vw;

      @media (max-width: ${breakpoints.screenSM}) {
        flex-direction: column;
        height: 100%;
      }
    }

    &.lower {
      height: 25vw;

      @media (max-width: ${breakpoints.screenSM}) {
        flex-direction: column-reverse;
        height: 100vw;
      }
    }
  }

  .videos-column {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    width: 50%;

    @media (max-width: ${breakpoints.screenSM}) {
      gap: 0.3rem;
      width: 100%;
      height: 100vw;
    }
  }

  .videos-group {
    display: flex;
    gap: 0.4rem;
    width: 100%;

    @media (max-width: ${breakpoints.screenSM}) {
      gap: 0.3rem;
    }

    &.upper {
      height: 50%;
    }

    &.lower {
      height: 100%;
    }
  }

  .video {
    position: relative;
    background-size: cover;
    cursor: pointer;

    &:hover {
      .overlay {
        opacity: 1;
      }
    }

    &.large {
      width: 50%;
      height: 100%;

      @media (max-width: ${breakpoints.screenSM}) {
        width: 100%;
        height: 100vw;
      }
    }

    &.mid {
      width: 100%;

      &.upper {
        height: 50%;
      }

      &.lower {
        height: 100%;
      }
    }

    &.small {
      width: 50%;
      height: 100%;
    }
  }

  .video-1 {
    background-image: url('https://www.1home.io/xassets/videos-1.webp');
  }

  .video-2 {
    background-image: url('https://www.1home.io/xassets/videos-2.webp');
  }

  .video-3 {
    background-image: url('https://www.1home.io/xassets/videos-3.webp');
  }

  .video-4 {
    background-image: url('https://www.1home.io/xassets/videos-4.webp');
  }

  .video-5 {
    background-image: url('https://www.1home.io/xassets/videos-5.webp');
  }

  .video-6 {
    background-image: url('https://www.1home.io/xassets/videos-6.webp');
  }

  .video-7 {
    background-image: url('https://www.1home.io/xassets/videos-7.webp');
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 0.5rem;
    background-color: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    padding: 1.5rem;
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.3s ease-in-out;
  }
`
